export class UnexpectedError extends Error {
    type?: string;

    constructor(message?: string, type?: string, stack?: string) {
        super();
        this.name = "UnexpectedError";
        this.message = message ?? "Unexpected error";
        this.type = type;
        this.stack = stack;
    }
}
